import React, { Component } from 'react';
import _isEmpty from 'lodash/isEmpty';

import Button from '../form/Button';
import CheckinCard from './CheckinCard';
import CommentsCard from './CommentsCard';
import EvidenceCard from './EvidenceCard';
import FilesCard from './FilesCard';
import StatusCard from './StatusCard';
import Subnav from '../subnav';

import CriterionApi from '../../api/criterion';
import PracticeApi from '../../api/practice';

import withEhsPageBehavior from '../../withEhsPageBehavior';

class CriterionDashboardPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isPrimary: null,
      practiceId: null,
      practiceName: null,
      criterion: null,
      criterionChanges: {},
      criterionSaveErrorMessage: null,
      criterionSaving: false,
      organizationId: null,
      disableCriterion: false,
    };

    this.getPracticeDetails = this.getPracticeDetails.bind(this);
    this.shouldDisableCriterion = this.shouldDisableCriterion.bind(this);
    this.onCriterionChange = this.onCriterionChange.bind(this);
    this.onVirtualCheckinChange = this.onVirtualCheckinChange.bind(this);
    this.handleSaveCriterion = this.handleSaveCriterion.bind(this);
  }

  componentDidMount() {
    const criterionId = this.props.match.params.criterionId;

    CriterionApi.getDetails(criterionId)
      .then(criterion => {
        this.setState({
          criterion: criterion,
        });
      }).then(async () => {
        await this.getPracticeDetails(this.state.criterion.practice_id);
      })
      .then(() => {
        const disable = this.shouldDisableCriterion()
        this.setState({ disableCriterion: disable });
      });
  }

  async getPracticeDetails(practiceId) {
    if (!practiceId) {
      return;
    }
    await PracticeApi.get(practiceId).then(practice => {
      this.setState({
        isPrimary: practice.primary_practice,
        practiceId: practice.id,
        practiceName: practice.name,
        organizationId: practice.organization_id,
      });
    });
  }

  handleSaveCriterion() {
    if (!_isEmpty(this.state.criterionChanges)) {
      this.setState({ criterionSaving: true });
      CriterionApi.updateCriterion(
        this.state.criterion.id,
        this.state.criterionChanges
      )
        .then(result => {
          this.setState({
            criterion: Object.assign(this.state.criterion, result.data),
            criterionChanges: {},
            criterionSaving: false,
          });
        })
        .catch(error => {
          this.setState({
            criterionSaving: false,
            criterionSaveErrorMessage: 'Unable to change criterion.',
          });
        });
    }
  }

  shouldDisableCriterion() {
    const { criterion, isPrimary } = this.state;
    const isNonPrimary = isPrimary !== null && !isPrimary;
    const isSharedCriterion =
      criterion && criterion.scope && criterion.scope === 'Shared';

    // Items are disabled if the criteria is shared an a non-primary practice.
    return isSharedCriterion && isNonPrimary;
  }

  onCriterionChange(criterionChanges) {
    this.setState({      
      criterionChanges: Object.assign(
        this.state.criterionChanges,
        criterionChanges
      ),
      criterion: Object.assign(this.state.criterion, criterionChanges),
    });
  }

  onVirtualCheckinChange(checkboxValue) {
    let change = { virtual_checkin: checkboxValue };
    change.status = checkboxValue === true ? 'Review Ready' : 'Not Started';
    this.setState({
      criterionChanges: Object.assign(this.state.criterionChanges, change),
      criterion: Object.assign(this.state.criterion, change),
    });
  }

  render() {
    const criterion = this.state.criterion || {};
    const evidence = criterion.evidence || [];
    const { disableCriterion } = this.state

    return (
      <main className="page">
        <div className="page__subnav">
          <Subnav
            practiceId={this.state.practiceId}
            organizationId={this.state.organizationId}
          />
        </div>
        <div className="page__header">
          <h2>
            <i className="fa fa-check-square-o" />
            {criterion.description}
          </h2>

          <div className="HeaderMeta">
            {this.state.practiceName} <br />[{criterion.type} Criteria -{' '}
            {criterion.scope}] &nbsp;
            {criterion.concept_code} - {criterion.concept}
            &nbsp;- {criterion.competency}
          </div>
        </div>

        <div className="sidebarpage CriterionDashboardPage">
          <div className="sidebarpage__content">
            <div className="Card">
              <h3>Files</h3>
              <FilesCard
                criterion={criterion}
                disableCriterion={disableCriterion}
              />
            </div>
            <div className="Card">
              <h3>Evidence</h3>
              {evidence.map((item, idx) => {
                return <EvidenceCard key={idx} evidence={item} />;
              })}
            </div>
          </div>
          <div className="sidebarpage__sidebar">
            <div className="Card">
              <h3>Status</h3>
              <StatusCard
                criterion={criterion}
                onCriterionChange={this.onCriterionChange}
                disableCriterion={disableCriterion}
              />

              <h3>Check-in</h3>
              <CheckinCard
                criterion={criterion}
                onCriterionChange={this.onCriterionChange}
                disableCriterion={disableCriterion}
              />

              <div className="SaveButton">
                <Button
                  defaultText="Save"
                  busyText="Saving..."
                  isbusy={this.state.criterionSaving}
                  onClick={this.handleSaveCriterion}
                  disableCriterion={disableCriterion}
                />
              </div>
            </div>
            <div className="Card">
              <h3>Comments</h3>
              <CommentsCard
                comments={criterion.comments}
                criterionId={criterion.id}
              />
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default withEhsPageBehavior(CriterionDashboardPage);
